<template>
    <v-page-data-table
            title="公文管理"
            key-name="id"
            :fields="fields"
            ref="doc"
            @create="onDetail"
            :show-edit="false"
            :row-actions="rowActions"
            :toolbar-actions="toolActions"
            delete-api="DOC_DELETE"
            query-api="DOC_QUERY">

        <template v-slot:title="{item}">
            <v-link-text :text="item.title" @click="onDetail(item)"></v-link-text>
        </template>
    </v-page-data-table>
</template>

<script>
    import DocQueryFields from "./fields/DocQueryFields";

    export default {
        name: "DocQuery",
        data() {
            return {
                fields: DocQueryFields,
                rowActions: [],
                toolActions: [
                    {
                        text: '新建公文',
                        color: 'primary',
                        icon: "mdi-plus-circle",
                        action: 'create'
                    }
                ]
            }
        },
        methods: {
            onDetail(item) {
                let id = item ? item.id : undefined;
                this.$router.apmRoute("docDetail", {id: id});
            },
            viewImage(url) {
                window.open(url, '_blank');
            }
        }
    }
</script>
